export const ATTENTIVEDRIVINGKEYTRANSLATOR: Record<string, string> = {
    'accelerator_pedal': 'Pedal do Acelerador',
    'tacho_speed': 'Velocidade do Tacógrafo',
    'engine_speed': 'Rotação do Motor',
    'fuel_level': 'Nível de Combustível',
    'electric_range': 'Autonomia Elétrica',
    'fuel_consumption': 'Consumo de Combustível',
    'wheel_speed': 'Velocidade da Roda',
    'instantaneous_fuel_economy': 'Consumo Instantâneo'
};